/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAccessRelationshipsResponse } from './UserAccessRelationshipsResponse';
import {
    UserAccessRelationshipsResponseFromJSON,
    UserAccessRelationshipsResponseFromJSONTyped,
    UserAccessRelationshipsResponseToJSON,
    UserAccessRelationshipsResponseToJSONTyped,
} from './UserAccessRelationshipsResponse';
import type { UserPlanResponse } from './UserPlanResponse';
import {
    UserPlanResponseFromJSON,
    UserPlanResponseFromJSONTyped,
    UserPlanResponseToJSON,
    UserPlanResponseToJSONTyped,
} from './UserPlanResponse';
import type { UserAccessLimitsResponse } from './UserAccessLimitsResponse';
import {
    UserAccessLimitsResponseFromJSON,
    UserAccessLimitsResponseFromJSONTyped,
    UserAccessLimitsResponseToJSON,
    UserAccessLimitsResponseToJSONTyped,
} from './UserAccessLimitsResponse';
import type { UserIdentityResponse } from './UserIdentityResponse';
import {
    UserIdentityResponseFromJSON,
    UserIdentityResponseFromJSONTyped,
    UserIdentityResponseToJSON,
    UserIdentityResponseToJSONTyped,
} from './UserIdentityResponse';
import type { UserEntitlementResponse } from './UserEntitlementResponse';
import {
    UserEntitlementResponseFromJSON,
    UserEntitlementResponseFromJSONTyped,
    UserEntitlementResponseToJSON,
    UserEntitlementResponseToJSONTyped,
} from './UserEntitlementResponse';

/**
 * 
 * @export
 * @interface UserAccessResponse
 */
export interface UserAccessResponse {
    /**
     * 
     * @type {UserIdentityResponse}
     * @memberof UserAccessResponse
     */
    identity: UserIdentityResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserAccessResponse
     */
    globalRoles: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserAccessResponse
     */
    effectiveRoles: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserAccessResponse
     */
    capabilities: Array<string>;
    /**
     * 
     * @type {UserPlanResponse}
     * @memberof UserAccessResponse
     */
    currentPlan: UserPlanResponse;
    /**
     * 
     * @type {UserAccessRelationshipsResponse}
     * @memberof UserAccessResponse
     */
    relationships: UserAccessRelationshipsResponse;
    /**
     * 
     * @type {UserAccessLimitsResponse}
     * @memberof UserAccessResponse
     */
    limits: UserAccessLimitsResponse;
    /**
     * 
     * @type {Array<UserEntitlementResponse>}
     * @memberof UserAccessResponse
     */
    entitlements: Array<UserEntitlementResponse>;
}

/**
 * Check if a given object implements the UserAccessResponse interface.
 */
export function instanceOfUserAccessResponse(value: object): value is UserAccessResponse {
    if (!('identity' in value) || value['identity'] === undefined) return false;
    if (!('globalRoles' in value) || value['globalRoles'] === undefined) return false;
    if (!('effectiveRoles' in value) || value['effectiveRoles'] === undefined) return false;
    if (!('capabilities' in value) || value['capabilities'] === undefined) return false;
    if (!('currentPlan' in value) || value['currentPlan'] === undefined) return false;
    if (!('relationships' in value) || value['relationships'] === undefined) return false;
    if (!('limits' in value) || value['limits'] === undefined) return false;
    if (!('entitlements' in value) || value['entitlements'] === undefined) return false;
    return true;
}

export function UserAccessResponseFromJSON(json: any): UserAccessResponse {
    return UserAccessResponseFromJSONTyped(json, false);
}

export function UserAccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'identity': UserIdentityResponseFromJSON(json['identity']),
        'globalRoles': json['globalRoles'],
        'effectiveRoles': json['effectiveRoles'],
        'capabilities': json['capabilities'],
        'currentPlan': UserPlanResponseFromJSON(json['currentPlan']),
        'relationships': UserAccessRelationshipsResponseFromJSON(json['relationships']),
        'limits': UserAccessLimitsResponseFromJSON(json['limits']),
        'entitlements': ((json['entitlements'] as Array<any>).map(UserEntitlementResponseFromJSON)),
    };
}

export function UserAccessResponseToJSON(json: any): UserAccessResponse {
    return UserAccessResponseToJSONTyped(json, false);
}

export function UserAccessResponseToJSONTyped(value?: UserAccessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'identity': UserIdentityResponseToJSON(value['identity']),
        'globalRoles': value['globalRoles'],
        'effectiveRoles': value['effectiveRoles'],
        'capabilities': value['capabilities'],
        'currentPlan': UserPlanResponseToJSON(value['currentPlan']),
        'relationships': UserAccessRelationshipsResponseToJSON(value['relationships']),
        'limits': UserAccessLimitsResponseToJSON(value['limits']),
        'entitlements': ((value['entitlements'] as Array<any>).map(UserEntitlementResponseToJSON)),
    };
}

